import { render, staticRenderFns } from "./dealForm.vue?vue&type=template&id=153c2cd8&scoped=true"
import script from "./dealForm.vue?vue&type=script&lang=js"
export * from "./dealForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153c2cd8",
  null
  
)

export default component.exports